/**
 *
 * RatingCard
 *
 */

import React, {
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ratingsOption } from './constants';


const RatingCardContainer = styled.div`
  background: ${p => p.theme.palette.blue5};
  border: 1px solid ${p => p.headerBackgroundColor || p.theme.palette.blue3};
  border-radius: 20px 20px 5px 20px;
  padding: 16px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;


const RatingCardMessage = styled.p`
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${p => p.theme.palette.riverBed};
  opacity: 0.8;
  max-width: 248px;
  margin: 0;
  margin-bottom: 10px;
  overflow-wrap: break-word;
`;

const RatingIconsContainer = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 260px;
  margin-bottom: 10px;
  margin-top: 4px;


`;

const RatingIcon = styled.img`
  width: 32px;
  transition: transform 0.1s;
  border-radius: 100px;
  cursor: pointer;
`;

const RatingIconContainer = styled.div`
  cursor: pointer;
  &:hover {
    ${RatingIcon} {
      transform: scale(1.3);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
  flex-grow: 1;
`;


const RatingResponseText  = styled.p`
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: ${p => p.theme.palette.riverBed};
  opacity: 0.5;
  margin: 0;
`;

const RatingHoveredText = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${p => p.headerBackgroundColor};
  margin: 0;
`;

const RatingCardSubmitted = styled(({ headerBackgroundColor, headerTextColor, children, ...others }) => (
  <div {...others}>{children}</div>
))`
  display: flex;
  align-items: center;
  margin-left: auto;
  overflow-wrap: break-word;
  float: right;
  background-color: ${p => p.headerBackgroundColor || p.theme.palette.blue3};
  color: ${p => p.headerTextColor || 'white'};
  border-radius: 15px 15px 5px 15px;
  padding: 10px 20px;
  text-align: left;
  max-width: 250px;
  white-space: pre-wrap;
  span {
    margin-left: 10px;
  }
`;


export const RatingCancel = styled.button`
  font-size: 12px;
  line-height: 14px;
  color: ${p => p.theme.palette.text.secondary};
  opacity: 0.3;
  border: none;
  background: transparent;
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
`;

export const RatingCard = ({message, userSettingColor, processUserResponse, Language,...props}) => {
  let feedback = message ? (message.feedback? message.feedback : {}) : {};
  let [ratingCardMessage, setRatingCardMessage] = useState(null);
  let [hoveredRating, setHoveredRating] = useState(null);

  let isCancellable = feedback.hasOwnProperty('isCancellable') && !feedback.isCancellable ? false : true;


  useEffect(() => {
    if (feedback && feedback.message) setRatingCardMessage(feedback.message);

  }, []);

  if (feedback && feedback.submitted) {

    let ratingValue = ratingsOption(Language)[(feedback.value - 1) || 0]
    return (
      <RatingCardSubmitted
        headerBackgroundColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
        headerTextColor={userSettingColor ? userSettingColor.headerTextColor : null}
      >
        <img src={ratingValue.icon}  alt={ratingValue.name} />
        <span>
          {ratingValue.name}
        </span>
      </RatingCardSubmitted>
    );
  }
  if(message) message.isCancellable = isCancellable;
  if (feedback && feedback._id) message._id = feedback._id;
  return (
    <RatingCardContainer
        id="insent-rating-card-rating-card-container"
      headerBackgroundColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
    >
      {ratingCardMessage && (<RatingCardMessage>{ratingCardMessage}</RatingCardMessage>)}
      <RatingIconsContainer  className="d-flex justify-content-between align-items-center">
        {ratingsOption(Language).map((ratingOption) => (
          <RatingIconContainer
              id="insent-rating-card-rating-icon-container"
            key={ratingOption.name}
            onMouseOver={() => setHoveredRating(ratingOption.name)}
            onMouseLeave={() => setHoveredRating(null)}
            onClick={() => processUserResponse({ value: ratingOption.rating, submitted: true }, message.type, { ...message })}
          >
          <RatingIcon
              id="insent-rating-card-rating-icon"
            src={ratingOption.icon}
            alt={ratingOption.name}
            />
          </RatingIconContainer>
      ))}
      </RatingIconsContainer>
      {hoveredRating ? (
        <RatingHoveredText id="insent-rating-card-rating-hovered-text" headerBackgroundColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}>
          {hoveredRating}
        </RatingHoveredText>
      ): (
        <RatingResponseText id="insent-rating-card-rating-hovered-text">
          {Language && Language.RatingCardRateYourExperience}
        </RatingResponseText>
      )}
      {isCancellable && (<RatingCancel onClick={() => processUserResponse({submitted: false}, message.type, { ...message, cancelled: true,  })}>
        {Language && Language.Cancel}
      </RatingCancel>)}
    </RatingCardContainer>
  );
}

RatingCard.propTypes = {};

export default RatingCard;
